import * as React from 'react'
import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'
import { Violation } from '@/app/types/creator'

import { useViolations } from '@/modules/drivers/hooks/useViolations'
import { ViolationModel } from '@/app/models/violationModel'
import ViolationDetailsTable from './ViolationDetailsTable'
import { faChevronDownSolid, FaIcon } from '@/lib/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { DRIVER_ROUTES } from '@/modules/drivers/routes-typed'

export const ViolationRowItem = ({
  violation,
  search,
}: {
  violation: Violation | any
  search: string
}) => {
  const navigate = useNavigate()
  const { companyId } = useParams<{ companyId: string }>()
  const { getViolations } = useViolations()
  const [isHovered, setIsHovered] = React.useState(false)
  const [isExpanded, setIsExpanded] = React.useState(false)
  const [subTableData, setSubTableData] = React.useState<ViolationModel[]>([])
  const [isLoadingDetails, setIsLoadingDetails] = React.useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const highlightMatch = (text: string, search: string) => {
    if (!search) return text
    const regex = new RegExp(`(${search})`, 'gi')
    const parts = text.split(regex)

    return (
      <div>
        {parts.map((part, index) =>
          regex.test(part) ? (
            <span key={index} className="tw-bg-[#FFF47B]">
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </div>
    )
  }

  const fetchDetails = async () => {
    if (isExpanded) {
      setIsExpanded(false)
      return
    }

    if (subTableData.length === 0) {
      setIsLoadingDetails(true)
      try {
        const data = await getViolations({ driverId: violation?.driverId })
        setSubTableData(data || [])
        setIsExpanded(true)
      } catch (err) {
        console.error('Error fetching violation details:', err)
      } finally {
        setIsLoadingDetails(false)
      }
    } else {
      setIsExpanded(true)
    }
  }
  const { range } = useDate()
  const handleRowDoubleClick = (violation: any) => {
    if (!companyId || !violation?.driverId) return

    navigate(
      DRIVER_ROUTES.violationsNew.buildPath({
        companyId: companyId,
        driverId: Number(violation.driverId),
        from: range.startDate.fullDate,
        to: range.endDate.fullDate,
      }),
    )
  }

  return (
    <>
      <tr
        className={`notches-border--right tw-relative tw-w-fit tw-cursor-pointer tw-border-b hover:tw-bg-primary/10 tw-bg-white `}
        onClick={fetchDetails}
        onDoubleClick={() => handleRowDoubleClick(violation)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
       
        <TableTextRow size="medium" textSize="sm">
          {highlightMatch(violation?.fullName || '', search)}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_NN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_BPN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_PN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          {violation?.amount_ZN ?? '-'}
        </TableTextRow>
        <TableTextRow size="medium" textSize="sm">
          <div className="tw-flex tw-w-full tw-items-center tw-justify-between">
            <p>
              {(
                (violation?.driverCharge ?? 0) + (violation?.companyCharge ?? 0)
              ).toFixed(2)}
            </p>
            <div
              className={`tw-rounded-lg tw-bg-secondary tw-p-1 ${isExpanded ? 'tw-rotate-180' : ''} tw-transition-transform`}
            >
              <FaIcon className="tw-h-4 tw-w-4" icon={faChevronDownSolid} />
            </div>
          </div>
        </TableTextRow>
      </tr>
      {isExpanded && (
        <tr className="tw-border-b-2 tw-border-b-gray-300 tw-border-t-2 tw-border-t-gray-300">
          <td colSpan={7} className="tw-bg-[#F2F2F2]/25 tw-py-0 tw-pl-0 tw-pr-2 tw-shadow-inner">
            <div className="tw-flex">
              <div className="tw-w-1 tw-flex-shrink-0 tw-bg-primary/30" />
              <div className="tw-flex-1">
                <ViolationDetailsTable
                  violations={subTableData}
                  isLoadingDetails={isLoadingDetails}
                  driverId={violation?.driverId}
                />
              </div>
            </div>
          </td>
        </tr>
      )}
      {/* {isExpanded && (
        <tr className="tw-border-b tw-border-base-300">
          <td colSpan={7} className="tw-bg-[#F2F2F240] tw-px-2 tw-py-0">
            <BaseTable
              bodyClassName="tw-border-b-transparent tw-text-content-base/80"
              headerClassName="tw-border-t-transparent tw-bg-transparent tw-text-content-base/80"
              headers={violationHeaders}
              items={subTableData}
              isLoading={isLoadingDetails}
            />
          </td>
        </tr>
      )} */}
    </>
  )
}
